import { WallButton } from "@package/ui-components";
import { EventPayloadType } from "@package/ui-gql/index-analytics";
import { useWallAnalytics, useWallProvider } from "@package/ui-wall";
import { get } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { type FlyoutProps } from "../../utils/flyout-props";

const DEFAULT_STALE_TIMEOUT = 60;

export function FlyoutIframe({ screen }: FlyoutProps) {
  const provider = useWallProvider();
  const { trigger } = useWallAnalytics();

  const [secondsRemaining, setSecondsRemaining] = useState<number>(
    screen.flyout?.staleTimeout || DEFAULT_STALE_TIMEOUT,
  );

  const iFrameUrl = useMemo<string>(
    () =>
      screen.flyout?.post
        ? get(screen.flyout.post, "customData.iframeFlyout.iFrameUrl")
        : "",
    [screen.flyout?.post],
  );
  const iframeKeepAliveButton = useMemo<boolean>(
    () =>
      screen.flyout?.post
        ? !!get(screen.flyout.post, "customData.flyout.iframeKeepAliveButton")
        : false,
    [screen.flyout?.post],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev <= 0) {
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative h-full w-full">
      <iframe src={iFrameUrl} width="100%" height="100%" />
      {iframeKeepAliveButton && (
        <div className="absolute bottom-4 left-0">
          <WallButton
            align="left"
            icon="stopwatch"
            intent={secondsRemaining <= 10 ? "warning" : "none"}
            muted
            text={`${Math.floor(secondsRemaining / 60)}:${(
              "0" +
              (secondsRemaining % 60)
            ).slice(-2)}`}
            onHandleMouse={(x, y) => {
              if (screen.flyout?.post) {
                provider?.onFlyoutInteracted(screen.id, screen.flyout.post);
                setSecondsRemaining(
                  screen.flyout?.staleTimeout || DEFAULT_STALE_TIMEOUT,
                );
                trigger(
                  EventPayloadType.PostTimeExtended,
                  {
                    screen: screen.index,
                    position: {
                      x,
                      y,
                    },
                  },
                  screen.flyout?.post?.id ?? undefined,
                  screen.layout?.id ?? undefined,
                );
              }
            }}
          />
        </div>
      )}
    </div>
  );
}
